import { render, staticRenderFns } from "./DotDotDots.vue?vue&type=template&id=57df728d&"
import script from "./DotDotDots.vue?vue&type=script&lang=js&"
export * from "./DotDotDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports